<template>
    <footer class="text-center">
        <b-container fluid>
            <b-row align-h="between" align-v="end">
                <b-col cols="12">
                    <dl>
                        <!-- <dt>{{ $t('footer.directedTitle')}}</dt>
                    <dd>{{ $t('footer.directed')}}</dd> -->
                        <dt>{{ $t('footer.organizerTitle')}}</dt>
                        <dd>{{ $t('footer.organizer')}}</dd>
                        <dt>{{ $t('footer.executiveTitle')}}</dt>
                        <dd>{{ $t('footer.executive')}}</dd>
                        <dt>{{ $t('footer.ANIHWebsiteTitle')}}</dt>
                        <dd><a href="https://anih.culture.tw">https://anih.culture.tw</a></dd>
                        <dt>{{ $t('footer.ANIHFacebookTitle')}}</dt>
                        <dd><a href="https://www.facebook.com/ANIH.ASIA/"> https://www.facebook.com/ANIH.ASIA/</a></dd>
                    </dl>
                </b-col>
                <b-col cols="12">{{ $t('footer.copyright')}}</b-col>
            </b-row>
        </b-container>
    </footer>
</template>

<script>
    export default {
        name: 'Footer'
    }
</script>